import React, { useEffect, useContext, useState, useRef } from 'react';
import { UserContext } from '../../context/UserContextProvider';
import SweepsBranchManagement from './SweepsBranchManagement';
import { searchAgencies } from "../../api/search";
import '../../styles/Sweeps.css';
import { Link } from 'react-router-dom';
import SweepDetailsContainer from './SweepDetailsContainer';

export default function SweepsAccountManagement({ agencyProfile, setAgencyProfile }) {

    const user = useContext(UserContext);
    const [toggleUpdate, setToggleUpdate] = useState(false);
    const [agencyBranches, setAgencyBranches] = useState([]);

    useEffect(() => {
        searchAgencies({ parentAgencyId: user?.agencyId, isBranch: true },
            response => {
                setAgencyBranches(response);
            }
        );
    }, []);

    return (
        <div className="col-sm-12 sweeps">
            <h3 className="header-padding">Agency</h3>
            <div>
                <SweepDetailsContainer agencyProfile={agencyProfile} setAgencyProfile={setAgencyProfile} isPrinciple={agencyProfile?.sweepDetails?.IsSweepsEnrolled} agencyBranches={agencyBranches} setAgencyBranches={setAgencyBranches} setToggleUpdate={setToggleUpdate} />
            </div>

            {!agencyProfile?.sweepDetails?.IsSweepsEnrolled && (
                <div className="col-md-12" >
                    <div style={{ textAlign: "right" }}>
                        <Link to="/email-settings" className="btn btn--primary" state={{ agencyProfile: agencyProfile }}>Enroll</Link>
                    </div>
                </div>
            )}
            <div className="col-md-12">
                <SweepsBranchManagement agencyProfile={agencyProfile} setAgencyProfile={setAgencyProfile} agencyBranches={agencyBranches} setAgencyBranches={setAgencyBranches} toggleUpdate={toggleUpdate} />
            </div>
        </div>
    );
};

